/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventScopeFilter } from './eventScopeFilter';


export interface EventIncludeFilterItems { 
    relation?: EventIncludeFilterItems.RelationEnum;
    scope?: EventScopeFilter;
}
export namespace EventIncludeFilterItems {
    export type RelationEnum = 'typeEvent' | 'companies' | 'users';
    export const RelationEnum = {
        TypeEvent: 'typeEvent' as RelationEnum,
        Companies: 'companies' as RelationEnum,
        Users: 'users' as RelationEnum
    };
}


